import { api_GET, api_POST, api_PUT } from './_api';

const autoInfracao_api = {
    GetImpressaoAutoInfracao: (hash) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`AutoInfracao/GetImpressaoAutoInfracao/${hash}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }, 
    GetList: (semDataVisualizacao = null) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`AutoInfracao/GetList/${semDataVisualizacao ?? ""}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },  
    Insert: (obj) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`AutoInfracao`, obj)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    UpdateDataVisualizacao: (autoInfracao_id) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`AutoInfracao/UpdateDataVisualizacao/${autoInfracao_id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
}

export default autoInfracao_api;